var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNoData = function SvgNoData(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 99 87"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58 47h40v40H58z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#55C2EF",
    d: "M76.333 65.333v-10h3.334v10h10v3.334h-10v10h-3.334v-10h-10v-3.334z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58 47h40v40H58z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#55C2EF",
    d: "M76.333 65.333v-10h3.334v10h10v3.334h-10v10h-3.334v-10h-10v-3.334z",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 0h64v64H9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#55C2EF",
    d: "M42.104 13.333H65A2.667 2.667 0 0 1 67.667 16v37.333A2.667 2.667 0 0 1 65 56H17a2.667 2.667 0 0 1-2.667-2.667V10.667A2.667 2.667 0 0 1 17 8h19.77l5.334 5.333z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 8h64v64H1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#55C2EF",
    d: "M34.104 21.333H57A2.667 2.667 0 0 1 59.667 24v37.333A2.667 2.667 0 0 1 57 64H9a2.667 2.667 0 0 1-2.667-2.667V18.667A2.667 2.667 0 0 1 9 16h19.77l5.334 5.333z",
    opacity: 0.4
  }))));
};
export default SvgNoData;